import { EventRegisterForm } from './EventRegisterForm'
import { Overlay } from './Overlay'

import type { EventRegisterFormProps } from './EventRegisterForm'
import type { ReactElement } from 'react'

export function EventRegister({
  id,
  title,
  rodoRequired,
  hasPlaceLeft,
  date,
  place,
  placeUrl,
  onNewClick,
  close,
  accept,
}: EventRegisterFormProps & { close(): void }): ReactElement {
  return (
    <Overlay close={close}>
      <EventRegisterForm
        id={id}
        hasPlaceLeft={hasPlaceLeft}
        accept={accept}
        placeUrl={placeUrl}
        place={place}
        date={date}
        title={title}
        rodoRequired={rodoRequired}
        onNewClick={onNewClick}
      />
    </Overlay>
  )
}
